import axios from 'axios'
import { SAVINGS_PLAN_ENDPOINT } from 'common/backend/endpoints'

export async function getSimilaritiesPlan(id, fields) {
    const endpoint = `${SAVINGS_PLAN_ENDPOINT}/${id}/similarities?fields=${fields}`

    const { data } = await axios.get(endpoint)

    return data
}
